import React from 'react'
import { defineMessages, useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { Button, ButtonProps } from 'semantic-ui-react';

const m = defineMessages({  
  login: {
    id: 'Errors.ErrorPage.Login',
    defaultMessage: "S'identifier",
  },
});


export const LoginButton : React.FC<ButtonProps> = (props) => {
  const history = useHistory();
  const { formatMessage } = useIntl();

  const handleButtonClicked = () => history.push('/login');

  return (
    <Button {...props} onClick={handleButtonClicked}>
      {formatMessage(m.login)}
    </Button>
  )
}
